//generate actions from authSlice and export it
import { authSlice } from "./reducers";
export const { loginSuccess, logoutSuccess } = authSlice.actions;
export default authSlice.actions;
